import clsx from "clsx";
import { ReactNode } from "react";
import { ClassNameValue } from "tailwind-merge";

export const ContentWrapper = ({
  children,
  className = "",
}: {
  children: ReactNode;
  className?: ClassNameValue;
}) => {
  return (
    <div
      className={clsx(
        "max-w-7xl mx-auto space-y-4 my-4 px-4 2xl:px-0 min-h-[60dvh]",
        className
      )}
    >
      {children}
    </div>
  );
};
